<template>
  <div class="page-content coupon-list">
    <el-breadcrumb separator="/" class="egl-breadcrumb">
      <el-breadcrumb-item :to="{ path: '/coupon' }">{{ $locale("sideMenu.couponLib.coupon") }}</el-breadcrumb-item>
      <el-breadcrumb-item>{{ $locale("couponLib.serialCodeManagement") }}</el-breadcrumb-item>
    </el-breadcrumb>

    <h1 class="page-title">{{ $locale("couponLib.serialCodeManagement") }}</h1>

    <!-- Search Area -->
    <el-row :gutter="10" class="search-area">
      <el-col :span="12">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-input
              :placeholder="$locale('couponLib.voucherNumber') + ' / ' + $locale('couponLib.serialCode')"
              v-model="filter.serialCode"
              @keyup.enter.native="filter_fn"
            >
              <i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </el-col>
          <el-col :span="8">
            <el-select :placeholder="$locale('global.status')" v-model="filter.status">
              <el-option
                v-for="item in statusOption"
                :label="item.label"
                :value="item.value"
                :key="item.value"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <el-button class="egl-btn-yellow" @click="filter_fn">{{
              $locale("global.search")
            }}</el-button>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="12">
        <el-row :gutter="10">
          <el-col :span="14">
            <el-input
              :placeholder="$locale('form.ticket.plsEnterNum')"
              v-model="inputNum"
              oninput="value=value.replace(/[^\d-\d]+/g,'')"
            ></el-input>
          </el-col>
          <el-col :span="10">
            <el-button class="egl-btn-yellow" @click="publish_fn">{{ $locale("couponLib.issueTypeAll") }}</el-button>
            <el-button class="egl-btn-yellow" @click="updateAll_fn">{{ $locale("couponLib.collectiveEffect") }}</el-button>
            <el-button class="egl-btn-yellow export-btn" @click="exportCSV">{{ $locale("global.exportToCSV") }}</el-button>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <div class="table-module info-supplement-container">
      <h3 class="info-title">{{ $locale("global.total") }}：{{ pageCount }}</h3>
    </div>

    <el-table :data="tableData" class="egl-table list-table" stripe @sort-change="sortChange_fn">
      <el-table-column
        :prop="th.prop"
        :label="th.label"
        v-for="th in thead"
        :key="th.prop"
        :min-width="th.width"
        :align="th.align"
        :sortable="th.sortable"
      ></el-table-column>
      <el-table-column :label="$locale('global.control')" width="100" align="center">
        <template slot-scope="scope">
          <div class="handle" v-if="scope.row.status != 'USED'">
            <a
              v-if="scope.row.status == 'EXPIRED' || scope.row.status == 'ISSUED'"
              @click="updateStatus_fn('ACTIVATED', scope.row.id)"
            >{{ $locale("global.valid") }}</a>
            <el-divider direction="vertical" v-if="scope.row.status == 'ISSUED'"></el-divider>
            <a
              v-if="scope.row.status == 'ACTIVATED' || scope.row.status == 'ISSUED'"
              @click="updateStatus_fn('EXPIRED', scope.row.id)"
            >{{ $locale("global.invalid") }}</a>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <CommPagination
      :total="pageCount"
      :curPage="onSearch.page"
      :pageSize="onSearch.pageSize"
      @current-change="choosePage"
    />
  </div>
</template>

<script>
import {
  getCouponExchangeList, saveAllCouponExchange, updateStatusCouponExchange, updateAllCouponExchange, getCouponTypeListForSelect
} from "@/helpers/service/api/coupon.js";
import countDownAlert from "@/utils/countDownAlert";
import CommPagination from "@/components/common/CommPagination";
import "@/assets/style/coupon.less";

export default {
  name: "couponList",
  data() {
    return {
      onSearch: {
        serialCode: "",
        status: "",
        couponType: "COUPON",
        couponTypeId: "",
        page: 0,
        pageSize: 10,
        sortType: "",
        sortKey: ""
      },
      filter: {
        serialCode: "",
        status: ""
      },
      pageCount: 0,
      inputNum: "",
      tableData: [],
      thead: [
        {
          prop: "couponName",
          label: "名前",
          width: 160,
          align: "center",
        },
        {
          prop: "number",
          label: this.$locale("couponLib.couponNumber"),
          width: 140
        },
        {
          prop: "serialCode",
          label: this.$locale("couponLib.serialCode"),
          width: 200
        },
        {
          prop: "useNumber",
          label: this.$locale("couponLib.useNumber"),
          width: 120
        },
        {
          prop: "issuedDateText",
          label: this.$locale("couponLib.issueDate"),
          width: 180,
          sortable: "custom"
        },
        {
          prop: "activatedDateText",
          label: this.$locale("couponLib.activationDate"),
          width: 180,
          sortable: "custom"
        },
        {
          prop: "expiredDateText",
          label: this.$locale("couponLib.expiredDate"),
          width: 180,
          sortable: "custom"
        },
        {
          prop: "orderId",
          label: this.$locale("couponLib.tradingCode"),
          width: 200
        },
        {
          prop: "usedDateText",
          label: this.$locale("couponLib.exchangeDate"),
          width: 180
        },
        {
          prop: "issuedTypeText",
          label: `${this.$locale("couponLib.issueTypeAll")} / ${this.$locale("couponLib.issueTypePOS")}`,
          width: 160,
          align: "center",
        },
        {
          prop: "statusText",
          label: this.$locale("global.status"),
          width: 160,
          align: "center",
        }
      ],
      statusOption: [],
    };
  },
  computed: {
    couponName() {
      const coupon = this.couponList.find(item => item.id === this.$route.params.id);
      return coupon ? coupon.name : "";
    }
  },
  methods: {
    filter_fn() {
      this.onSearch = { ...this.onSearch, ...this.filter, page: 0 };

      this.getData();
    },
    sortChange_fn(column) {
      const sortTypeMapping = {
        ascending: "ASC",
        descending: "DESC"
      };
      const sortKeyMapping = {
        issuedDateText: "issuedDate",
        activatedDateText: "activatedDate",
        expiredDateText: "expiredDate",
      };
      this.onSearch.sortType = sortTypeMapping[column.order];
      this.onSearch.sortKey = sortKeyMapping[column.prop];
      this.onSearch.page = 0;

      this.getData();
    },
    getData() {
      getCouponExchangeList(this.onSearch)
        .then(res => {
          let tableData = this.formatData(res.data.data);

          // this.pageCount = Math.ceil(res.data.count / this.onSearch.pageSize);
          this.pageCount = res.data.count || 0;
          this.tableData = tableData;
        })
        .catch(() => {});
    },
    couponDateFormatter(obj,key, text) {
      switch(obj[key]) {
      case -1:
        obj[text] = this.$locale("couponLib.none");
        break;
      case null:
        obj[text] = "";
        break;
      default:
        obj[text] = this.$moment(obj[key]).format("YYYY/MM/DD HH:mm");
        break;
      }
    },
    formatData(arr) {
      arr.map(obj => {
        this.couponDateFormatter(obj, "issuedDate", "issuedDateText");
        this.couponDateFormatter(obj, "activatedDate", "activatedDateText");
        this.couponDateFormatter(obj, "expiredDate", "expiredDateText");
        this.couponDateFormatter(obj, "usedDate", "usedDateText");
        // obj.issuedDateText = this.$moment(obj.issuedDate).format("YYYY/MM/DD HH:mm");
        // obj.activatedDateText = this.$moment(obj.activatedDate).format("YYYY/MM/DD HH:mm");
        // obj.expiredDateText = this.$moment(obj.expiredDate).format("YYYY/MM/DD");
        // obj.usedDateText = this.$moment(obj.usedDate).format("YYYY/MM/DD HH:mm");

        obj.issuedTypeText = "";
        obj.statusText = "";

        if (obj.issuedType == "CMS") {
          obj.issuedTypeText = this.$locale("couponLib.issueTypeAll");
        } else {
          obj.issuedTypeText = this.$locale("couponLib.issueTypePOS");
        }

        for (let i = 0; i < this.statusOption.length; i++) {
          if (this.statusOption[i].value == obj.status) {
            obj.statusText = this.statusOption[i].label;
            break;
          }
        }

        return obj;
      });

      return arr;
    },
    publish_fn() {
      if (this.inputNum != "") {
        let obj = {
          count: this.inputNum,
          couponType: this.onSearch.couponType,
          couponTypeId: this.onSearch.couponTypeId
        };

        saveAllCouponExchange(obj)
          .then(res => {
            if (res.success) {
              this.inputNum = "";
              this.countDown(this.$locale("global.operationSuccessful"));
            }
          })
          .catch(() => {});
      }
    },
    updateAll_fn() {
      if (this.inputNum != "") {
        let obj = {
          count: this.inputNum,
          couponType: this.onSearch.couponType,
          couponTypeId: this.onSearch.couponTypeId
        };

        updateAllCouponExchange(obj)
          .then(res => {
            if (res.success) {
              this.inputNum = "";
              this.countDown(this.$locale("global.operationSuccessful"));
            }
          })
          .catch(() => {});
      }
    },
    updateStatus_fn(status, id) {
      updateStatusCouponExchange(`id=${id}&status=${status}`)
        .then(res => {
          if (res.success) {
            this.countDown(this.$locale("global.updateSuccessfully"));
          }
        })
        .catch(() => {});
    },
    choosePage(page) {
      this.onSearch = { ...this.onSearch, page: page - 1 };

      this.getData();
    },
    countDown(str = this.$locale("global.createSuccessfully")) {
      countDownAlert({
        content: str,
        callback: () => {
          this.getData();
        }
      });
    },
    exportCSV() {
      if (this.pageCount > 0) {
        getCouponExchangeList({
          couponType: this.onSearch.couponType,
          couponTypeId: this.onSearch.couponTypeId,
          page: 0,
          pageSize: 9999999,
        }).then(res => {
          // 将couponName加入到exportCsv的column里
          const fileName = this.$locale("sideMenu.couponLib.coupon");
          const tableData = this.formatData(
            res.data.data.map(item => Object.assign({}, item, { couponName: this.couponName }))
          );
          
          let str = "";

          this.thead.map(item => {
            str = str + item.label + ",";
          });

          str = str.substring(0, str.length - 1);

          tableData.map(item => {
            str += "\n";

            this.thead.map(th => {
              str = str + item[th.prop] + ",";
            });

            str = str.substring(0, str.length - 1);
          });

          if (navigator.msSaveOrOpenBlob) {
            let BOM = "\uFEFF";
            let blob = new  Blob([ BOM + str ], { type: "text/csv;charset=utf-8;" });
            navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            let csvContent = "data:text/csv;charset=utf-8,\uFEFF" + str;
            let link = document.createElement("a");
            link.href = encodeURI(csvContent);
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        });
      }
    },
  },
  mounted() {
    let couponTypeId = this.$route.params.id;
    // 请求couponList
    // couponList mapping couponTypeId获取couponName
    getCouponTypeListForSelect({
      cinemaId: window.localStorage.getItem("cinemaId"),
      page: 0,
      pageSize: 999999,
      field: ["id", "name"]
    }).then(res => {
      this.couponList = res.data.data;
    });
    let statusOption = [
      {
        value: "ACTIVATED",
        label: this.$locale("couponLib.effective")
      },
      {
        value: "EXPIRED",
        label: this.$locale("couponLib.ineffective")
      },
      {
        value: "ISSUED",
        label: this.$locale("couponLib.issued")
      },
      {
        value: "USED",
        label: this.$locale("couponLib.used")
      }
    ];

    this.statusOption = statusOption;
    this.onSearch = { ...this.onSearch, couponTypeId };
    this.getData();
  },
  components: {
    CommPagination,
  }
};
</script>
